import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';

const UsuarioPerfilComboBox = ({ usuariosPerfil, usuarioPerfil, handleUsuarioPerfilChange }) => {
    return (
        <FormControl required fullWidth >
            <InputLabel id="turma-label">Usuário Perfil</InputLabel>
            <Select
                labelId="turma-label"
                id="turma-select"
                value={usuarioPerfil ? usuarioPerfil.codigo : ''}
                onChange={handleUsuarioPerfilChange}
            >
                {usuariosPerfil.map(up => (
                    <MenuItem key={up.codigo} value={up.codigo}>{up.usuario.nome}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default UsuarioPerfilComboBox;